
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EdataProductDTOFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EdataProductDTO"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gtin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manufacturerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manufacturerIdDuns"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manufacturerIdGln"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manufacturerPartNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"altPartNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gtin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"erpDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet6"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet7"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet8"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet9"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marketingBullet10"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deeplink"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"family"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"range"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"introductionDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"obsoleteDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumOrderQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumOrderQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"quantityInterval"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unspsc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tradeTariffCommodityCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryOfOrigin"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataQuality"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastChange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etim"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"className"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetFilename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetSource"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featureName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featureValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":891}};
    doc.loc.source = {"body":"fragment EdataProductDTOFragment on EdataProductDTO {\n  productId\n  status\n  gtin\n  manufacturerName\n  manufacturerIdDuns\n  manufacturerIdGln\n  manufacturerPartNumber\n  altPartNumber\n  gtin\n  shortDescription\n  longDescription\n  erpDescription\n  marketingBullet1\n  marketingBullet2\n  marketingBullet3\n  marketingBullet4\n  marketingBullet5\n  marketingBullet6\n  marketingBullet7\n  marketingBullet8\n  marketingBullet9\n  marketingBullet10\n  deeplink\n  brand\n  family\n  range\n  introductionDate\n  obsoleteDate\n  orderUnit\n  minimumOrderQuantity\n  maximumOrderQuantity\n  quantityInterval\n  unspsc\n  tradeTariffCommodityCode\n  countryOfOrigin\n  dataQuality\n  lastChange\n  etim {\n    classId\n    className\n    groupId\n    groupName\n  }\n  assets {\n    assetFilename\n    assetDescription\n    assetSource\n  }\n  features {\n    featureName\n    featureType\n    featureUnit\n    featureValue\n  }\n  images\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EdataProductDTOFragment"] = oneQuery(doc, "EdataProductDTOFragment");
        
